export const USUARIO_BASE_OBJ = {
  direccion: {
    calle: '',
    colonia: '',
    cp: '',
    estado: 0,
    estado_personalizado: '',
    municipio: 0,
    municipio_personalizado: '',
    pais: 13
  },
  email: '',
  email_alternativo:'',
  estatus: {
    estatus: ''
  },
  estatus_pago:{
    estatus: null, 
    fecha_pago: null, 
    id_suscripcion: null, 
    plan: null, 
    pruebas: false, 
    recurrente: false, 
    ya_uso_premium:false
  },
  foto: '',
  id_corporativo: '',
  id_franquicia: '',
  info:{
    apellidos: '',
    cargo: '',
    fecha_alta: new Date(),
    fecha_nacimiento: new Date(),
    nombre: '',
    sexo: '',
    telefonos: [],
    telefono_fijo:'',
  },
  info_complementaria: {
    afiliacion_seguro: '',
    cedula: '',
    curp: '',
    facebook: '',
    nombre: '',
    rfc: '',
    sucursales: [],
    telefono: '',
    tipo_sangre: '',
    twitter: '',
    id_caja_actual: null,
    id_corte_actual: null,
    ocupacion:'',
    medio_conocio:'',
    observaciones:'',
  },
  rol: ''
}

export const CORPORATIVO_BASE_OBJ = {
  info: { telefonos: {}, fecha_alta: {} },
  direccion: {},
  datos_fiscales: {}
}

export const ESTATUS_USUARIO = {
  ACTIVO: 'Activo',
  INACTIVO: 'Inactivo'
}

export const TIPO_PERFIL = {
  USUARIO: 'Usuario',
  PROPIETARIO: 'Propietario'
}

export const GRUPO_MODULO = {
  AGENDA: 'agenda',
  AUTORIZACION: 'autorizacion',
  CASOS: 'casos',
  PACIENTES: 'pacientes',
  PROPIETARIOS: 'propietarios',
  PLANES_BIENESTAR: 'planes_bienestar'
}

export const TIPO_NOTIFICACION = {
  PROGRAMADA: 'Programada',
  INMEDIATA: 'Inmediata'
}

export const STATUS_APP = {
  INICIAL: 'Inicial',
  CONFIGURACION_INICIAL: 'ConfiguracionInicial',
  ACTIVA: 'Activa'
}



// WEBPACK FOOTER //
// ./src/constantes/usuarios.js